import React, { useEffect, useRef, useState } from 'react';
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';
import './DashboardLayout.css';
import {
  ChevronDown,
  CodeXml,
  Film,
  LayoutDashboard,
  Palette,
  Plus,
  Settings,
  Menu,
  X,
  MegaphoneIcon,
  User,
  Lock,
  LogOut,
  QrCode
} from 'lucide-react';

import logo from "../../src/images/ctv_logo.png"


export default function DashboardLayout() {
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const [open, setOpen] = useState(false);
  const dropdownRef = useRef();
  const navigate = useNavigate();

  // const isActive = (path) =>
  //   location.pathname === path || location.pathname.startsWith(path + '/');

  const isActive = (path) => location.pathname === path;

  const closeSidebar = () => setSidebarOpen(false);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLogout = () => {
    // Clear auth here
    localStorage.clear();
    navigate("/sign-in");
  };

  return (
    <div className="dashboard-layout">

      {/* Overlay */}
      {sidebarOpen && (
        <div
          className="dashboard-overlay"
          onClick={closeSidebar}
        />
      )}

      {/* Sidebar */}
      <aside className={`dashboard-sidebar ${sidebarOpen ? 'open' : ''}`}>
        {/* Mobile Close Button */}
        <button
          className="sidebar-close-btn"
          onClick={closeSidebar}
        >
          <X size={20} />
        </button>

        <Link to="/" className="dashboard-logo" onClick={closeSidebar}>
          <span className="dashboard-logo-icon">
            {/* <Tv className="h-8 w-8 text-primary" /> */}
            <img src={logo} alt='logo' className="h-12 w-12 text-black" />
          </span>
          <span className='mt-2'>SocialTV</span>
        </Link>

        <Link
          to="/dashboard/editor"
          className={`dashboard-btn-new ${isActive('/dashboard/editor') ? 'active' : ''}`}
          onClick={closeSidebar}
        >
          <span className="dashboard-btn-plus">
            <Plus className="h-4 w-4" />
          </span>
          New Creative
        </Link>

        <nav className="dashboard-nav">
          <Link to="/dashboard" className={`dashboard-nav-item ${isActive('/dashboard') ? 'active' : ''}`} onClick={closeSidebar}>
            <span className="dashboard-nav-icon"><LayoutDashboard /></span>
            Dashboard
          </Link>

          <Link to="/templates" className={`dashboard-nav-item ${isActive('/templates') ? 'active' : ''}`} onClick={closeSidebar}>
            <span className="dashboard-nav-icon"><Palette /></span>
            Templates
          </Link>

          <Link to="/creatives" className={`dashboard-nav-item ${isActive('/creatives') ? 'active' : ''}`} onClick={closeSidebar}>
            <span className="dashboard-nav-icon"><Film /></span>
            Creatives
          </Link>

          <Link to="/campaign" className={`dashboard-nav-item ${isActive('/campaign') ? 'active' : ''}`} onClick={closeSidebar}>
            <span className="dashboard-nav-icon"><MegaphoneIcon /></span>
            Campaigns
          </Link>

          <Link to="/xml-tester" className={`dashboard-nav-item ${isActive('/xml-tester') ? 'active' : ''}`} onClick={closeSidebar}>
            <span className="dashboard-nav-icon"><CodeXml /></span>
            XML Tester
          </Link>
          <Link to="/qr-generator" className={`dashboard-nav-item ${isActive('/qr-generator') ? 'active' : ''}`} onClick={closeSidebar}>
            <span className="dashboard-nav-icon"><QrCode /></span>
            Dynamic QR code
          </Link>
        </nav>

        <div className="dashboard-nav-bottom hidden">
          {/* <Link to="/team" className="dashboard-nav-item" onClick={closeSidebar}>
            <span className="dashboard-nav-icon"><Users2Icon /></span>
            Team
          </Link> */}

          <Link to="/settings" className="dashboard-nav-item" onClick={closeSidebar}>
            <span className="dashboard-nav-avatar">
              <Settings />
            </span>
            Settings
          </Link>
        </div>
      </aside>

      {/* Main */}
      <div className="dashboard-main">

        {/* Header */}
        <header className="dashboard-header">

          {/* Mobile Menu Button */}
          <button
            className="menu-btn"
            onClick={() => setSidebarOpen(true)}
          >
            <Menu />
          </button>

          <div />

          {/* <div className="dashboard-header-right">
            <div className="dashboard-user">
              <div className="dashboard-user-avatar bg-gradient-to-r from-slate-800 to-slate-700">
                J
              </div>
              <div className="dashboard-user-info">
                <span className="dashboard-user-name">John Doe</span>
                <span className="dashboard-user-role">Admin</span>
              </div>
              <span className="dashboard-user-chevron">
                <ChevronDown />
              </span>
            </div>
          </div> */}


          <div className="dashboard-header-right  relative" ref={dropdownRef}>
            <div
              onClick={() => setOpen(!open)}
              className="flex items-center gap-3 cursor-pointer "
            >
              <div className="w-10 h-10 rounded-full bg-gradient-to-r from-slate-800 to-slate-700 text-white flex items-center justify-center font-semibold">
                J
              </div>

              <div className="flex flex-col">
                <span className="text-sm font-medium text-gray-800">
                  John Doe
                </span>
                <span className="text-xs text-gray-500">Admin</span>
              </div>

              <ChevronDown size={22} className={`text-gray-600 transition-all duration-300 ${open ? "rotate-180" : "rotate-0"} `} />
            </div>

            {/* Dropdown */}
            {open && (
              <div className="absolute top-12 right-0 mt-3 w-52 bg-white shadow-xl rounded-2xl border border-slate-200 p-2 z-50">
                <button
                  onClick={() => { navigate("/profile"); setOpen(false); }}
                  className="flex items-center gap-3 w-full px-3 py-2 rounded-xl hover:bg-gray-100 transition text-sm"
                >
                  <User size={18} />
                  Profile
                </button>

                <button
                  onClick={() => { navigate("/change-password"); setOpen(false); }}
                  className="flex items-center gap-3 w-full px-3 py-2 rounded-xl hover:bg-gray-100 transition text-sm"
                >
                  <Lock size={18} />
                  Change Password
                </button>

                <hr className="my-2" />

                <button
                  onClick={handleLogout}
                  className="flex items-center gap-3 w-full px-3 py-2 rounded-xl hover:bg-red-50 text-red-600 transition text-sm"
                >
                  <LogOut size={18} />
                  Logout
                </button>
              </div>
            )}
          </div>


        </header>

        <div className="dashboard-content">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
